// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .scheduler-calendar .p-inputtext {
  border: 1px solid #ced4da;
  transition: background-color 0.3s ease;
}
:host ::ng-deep .scheduler-calendar .p-inputtext:hover {
  border-color: var(--ids-theme-inuit-forms-border_outer-hover);
}

.container-date {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
